exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host /deep/ .mat-slider-thumb {\n  background-color: #878787; }\n\n:host /deep/ .mat-slider-thumb-label {\n  background-color: #878787; }\n\n:host /deep/ .map-slider-horizontal .mat-slider-track-fill {\n  background-color: #878787; }\n\n:host /deep/ .map-slider-horizontal .mat-slider-track-background {\n  background-color: #878787; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Workspace/hyblab-migration/src/app/time-slider/time-slider.component.scss
// module id = ../../../../../src/app/time-slider/time-slider.component.scss
// module chunks = main